import { useCallback, useMemo } from 'react'

import Paragraph from '../app/design/Paragraph'
import SegmentedControl from '../app/design/SegmentedControl'

export type DiscreteSelectProps = {
    value?: number
    onChange?: (x: number) => void
    lower: number
    upper: number
}

/**
 * Takes an integer range and renders a {@link SegmentedControl} with those values
 * as well as explicitly emits integers.
 */
export function DiscreteSelect({ value, onChange, lower, upper }: DiscreteSelectProps) {
    const handleChange = useCallback(
        (value: string) => {
            onChange?.(parseInt(value, 10))
        },
        [onChange]
    )

    const segments = useMemo(() => {
        const segments = []
        for (let i = lower; i <= upper; i++) {
            const value = String(i)

            segments.push({
                label: value,
                value,
            })
        }
        return segments
    }, [lower, upper])

    return (
        <SegmentedControl
            compact
            segments={segments}
            value={String(value ?? '')}
            onChange={handleChange}
        />
    )
}

export type RatingSelectProps = DiscreteSelectProps & {
    lowSentiment: string
    highSentiment: string
}

/**
 * Likert scale labeled {@link DiscreteSelect}.
 */
export function RatingSelect({ lowSentiment, highSentiment, ...props }: RatingSelectProps) {
    return (
        <>
            <DiscreteSelect {...props} />
            <div className="flex justify-between text-gray-600">
                <Paragraph size="sm">{lowSentiment}</Paragraph>
                <Paragraph size="sm">{highSentiment}</Paragraph>
            </div>
        </>
    )
}
